import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import NavigationHeader from './NavigationHeader';
import HeroSection from './HeroSection';
import ServicesSection from './ServicesSection';
import AboutSection from './AboutSection';
import FeaturedProjectsSection from './FeaturedProjectsSection';
import TestimonialsSection from './TestimonialsSection';
import FAQSection from './FAQSection';
import MapSection from '../shared/MapSection';
import GMBFeedSection from '../shared/GMBFeedSection';
import TagsSection from '../shared/TagsSection';
import Footer from './Footer';

const TemplateContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  minHeight: '100vh',
  backgroundColor: '#F4F8FF'
}));

const Template6 = ({
  templateData,
  isEditable = false,
  onTemplateUpdate
}) => {
  const {
    businessInfo,
    navigation,
    serviceRequest,
    services,
    aboutUs,
    featuredProjects,
    testimonials,
    faq,
    contactInfo,
    footer,
    location,
    gmbFeed,
    categories
  } = templateData || {};

  return (
    <TemplateContainer>
      <NavigationHeader businessInfo={businessInfo} navigation={navigation} />
      <HeroSection businessInfo={businessInfo} serviceRequest={serviceRequest} />
      <ServicesSection services={services} />
      <AboutSection aboutUs={aboutUs} />
      <FeaturedProjectsSection featuredProjects={featuredProjects} />
      <TestimonialsSection testimonials={testimonials} businessInfo={businessInfo} />
      <MapSection location={location} />
      <GMBFeedSection gmbFeed={gmbFeed} />
      <FAQSection faq={faq} />
      <TagsSection
        businessInfo={businessInfo}
        categories={categories}
        contactInfo={contactInfo}
      />
      <Footer
        contactInfo={contactInfo}
        footer={footer}
        businessInfo={businessInfo}
        services={services}
      />
    </TemplateContainer>
  );
};

export default Template6;